/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface GatewayMembershipStatusRequest {

    /**
     * The date the membership will renew, or the date it was supposed to renew if it's past due.
     */
    renewal_due_date?: string;

    /**
     * True if the gateway subscription is canceled and cannot be reactivated.
     */
    canceled?: boolean;

    /**
     * True if the gateway subscription will not renew (because the membership is expiring or a problem occurred at the gateway).
     */
    cancel_at_period_end?: boolean;

    /**
     * True if the system considers this account past due.
     */
    past_due?: boolean;

    /**
     * True if the user should be granted entitlement based on the status of the gateway subscription including all applicable grace periods.
     */
    in_good_standing?: boolean;

    /**
     * The date the user will lose access if another payment is not received.
     */
    revocation_date?: string;

    /**
     * The date the user will next be charged
     */
    next_charge_date?: string;

    /**
     * The amount the user will next be charged
     */
    next_charge_amount?: string;

}

@Model('GatewayMembershipStatus')
export class ApiGatewayMembershipStatus extends BaseModel implements GatewayMembershipStatusRequest {

    /**
     * The date the membership will renew, or the date it was supposed to renew if it's past due.
     */
    
    
    renewal_due_date: string;

    /**
     * True if the gateway subscription is canceled and cannot be reactivated.
     */
    
    
    canceled: boolean;

    /**
     * True if the gateway subscription will not renew (because the membership is expiring or a problem occurred at the gateway).
     */
    
    
    cancel_at_period_end: boolean;

    /**
     * True if the system considers this account past due.
     */
    
    
    past_due: boolean;

    /**
     * True if the user should be granted entitlement based on the status of the gateway subscription including all applicable grace periods.
     */
    
    
    in_good_standing: boolean;

    /**
     * The date the user will lose access if another payment is not received.
     */
    
    
    revocation_date: string;

    /**
     * The date the user will next be charged
     */
    
    
    next_charge_date: string;

    /**
     * The amount the user will next be charged
     */
    
    
    next_charge_amount: string;

}
